<script>
  import { onMount } from "svelte";
  import Conexoes from "../Classes/Conexoes";
  import Constantes from "../Classes/Constantes";
  import LoadingTela from "../componentes_basicos/LoadingTela.svelte";
  import { DadosLogin } from "../Classes/Stores";

  let isLoading = false;
  let movimentos = [];
  let selectedMovimento = null;
  let referencia = null;
  let peso = 0;
  let error = null;
  let data = new Date().toISOString().slice(0, 10);
  let historicos = [];
  const conexao = new Conexoes();
  async function PegaDados() {
    isLoading = true;
    movimentos = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code:
        Constantes.query_code_consulta_generica_livre_sem_coluna_deletado,
      tabela: "prs_view",
    });
    isLoading = false;
  }
  async function PegaHistorico(id) {
    isLoading = true;
    historicos = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "consulta_historico_pr",
      id_usuario: $DadosLogin.id_usuario,
      id_movimento: id,
    });
    isLoading = false;
  }
  onMount(() => {
    PegaDados();
  });

  function handleMovimentoChange(event) {
    selectedMovimento = movimentos.find(
      (m) => m.movimento == event.target.value,
    );

    console.log(selectedMovimento.movimento);
    console.log(event.target.value);
    PegaHistorico(selectedMovimento.id);

    referencia = selectedMovimento ? selectedMovimento.referencia : null;
    peso = 0; // Resetar o peso ao mudar de movimento
  }

  function handlePesoChange(event) {
    peso = parseFloat(event.target.value);
  }

  async function salvar() {
    // Função de salvar sem comandos
    //data, usuario, id_movimento, valor
    let parametros = {};
    parametros["data"] = data;

    parametros["valor"] = peso;
    parametros["id_usuario"] = $DadosLogin.id_usuario;
    parametros["id_movimento"] = selectedMovimento.id;
    parametros["tabela"] = "prs_usuario";
    isLoading = true;
    let result = await conexao.conecta(
      Constantes.api_inserir_sem_query_code,
      parametros,
      true,
    );
    isLoading = false;
  }
  // Função para formatar a data no formato brasileiro
  function formatarData(dataISO) {
    const [ano, mes, dia] = dataISO.split("-");
    return `${dia}/${mes}/${ano}`;
  }
</script>

<LoadingTela {isLoading} />
<div class="margem">
  <div class="fonte">PRs e Porcentagens</div>

  <strong>Movimento:</strong>
  <div class="select-container">
    <select
      style="width: 100%; font-size: 18px;"
      id="movimento"
      on:change={handleMovimentoChange}
    >
      <option style="font-size: 18px;" value="" disabled selected
        >Selecione um movimento</option
      >
      {#each movimentos as movimento}
        <option style="font-size: 18px;" value={movimento.movimento}
          >{movimento.movimento}</option
        >
      {/each}
    </select>
  </div>
  <br />{#if referencia}
    <strong>Data do PR:</strong>
    <div class="select-container">
      <input
        style="width: 100%; font-size: 18px;"
        type="date"
        id="data"
        min="0"
        step="0.1"
        bind:value={data}
      />
    </div>
  {/if}

  {#if referencia === "Kg"}
    <strong>Peso (Kg):</strong>
    <div class="select-container">
      <input
        style="width: 100%; font-size: 18px;"
        type="number"
        id="peso"
        min="0"
        step="0.1"
        on:input={handlePesoChange}
      />
    </div>
  {:else if referencia === "Tempo"}
    <strong>Tempo (HH:MM:SS):</strong>
    <div class="select-container">
      <input
        style="width: 100%; font-size: 18px;"
        type="time"
        id="tempo"
        step="2"
      />
    </div>
  {/if}
  <br />

  {#if referencia}
    <button style="width: 100%" type="submit" on:click={salvar}>Salvar</button>
  {/if}
  <br /><br />

  {#if historicos.length}
    <div class="container mt-4">
      <h5 class="mb-3">Históricos</h5>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Movimento</th>
              <th scope="col">Data</th>
              <th scope="col">Marca</th>
            </tr>
          </thead>
          <tbody>
            {#each historicos as historico}
              <tr>
                <td>{historico.movimento}</td>
                {#if historico.data}
                  <td>{formatarData(historico.data)}</td>
                {:else}
                  <td></td>
                {/if}
                <td>{historico.valor}</td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  {/if}

  {#if referencia === "Kg" && peso > 0}
    <div style="display: flex; width: 100%">
      <div class="cabecalho">Porcentagem</div>
      <div class="cabecalho">Valor (Kg)</div>
    </div>

    {#each Array.from({ length: 17 }, (_, i) => 30 + i * 5) as porcentagem}
      <div style="display: flex; width: 100%">
        <div class="registro">{porcentagem}%</div>
        <div class="registro">{(peso * (porcentagem / 100)).toFixed(2)} Kg</div>
      </div>
    {/each}
  {/if}
</div>
<br />
<br />
<br />
<br />
<br />

<style>
  .fonte {
    font-size: 30px;
    font-weight: bold;
    color: #000080;
    text-align: center;
  }

  .cabecalho {
    text-align: center;
    border-radius: 5px; /* Define o arredondamento dos cantos */
    padding: 7px; /* Adiciona um preenchimento interno à div */
    background: #3385a2;
    color: white;
    font-size: 15px;
    font-weight: bold;
    margin: 0px;
    width: 50%;
  }

  .registro {
    text-align: center;
    border: 1px solid #95cadd;
    /*border-radius: 5px; /* Define o arredondamento dos cantos */
    padding: 7px; /* Adiciona um preenchimento interno à div */
    background: #ffffff;
    color: #216a85;
    font-size: 15px;
    font-weight: bold;
    margin: 0px;
    width: 50%;
  }

  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .select-container {
    display: flex;
    align-items: center;
  }

  input,
  select {
    border: 3px solid #9292ff;
    border-radius: 4px;
  }

  input,
  select,
  button {
    padding: 0.5rem;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    background-color: #1976d2;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  table {
    margin-top: 1rem;
    border-collapse: collapse;
    width: 100%;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 0.5rem;
    text-align: right;
  }

  th {
    background-color: #f2f2f2;
  }
</style>
